import React, { useState } from 'react';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Swal from 'sweetalert2';

function UploadFile({ setFile, resetShowData }) {
  const [fileDetails, setFileDetails] = useState(null);

  const handleChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    resetShowData();

    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
    ];

    if (!allowedTypes.includes(file.type)) {
      const fileExtension = file.name.split('.').pop();
      Swal.fire({
        title: 'ไฟล์ไม่ถูกต้อง',
        html: `ไม่รองรับไฟล์ <strong>.${fileExtension}</strong><br>กรุณาอัปโหลดไฟล์ที่มีนามสกุล <strong>.xlsx</strong>`,
        icon: 'error',
        confirmButtonColor: '#4FA893',
        confirmButtonText: 'ตกลง',
      });
      return;
    }

    // Set file details
    setFile(file);
    setFileDetails({
      name: file.name,
      size: (file.size / 1024).toFixed(2), // Size in KB
      lastModified: new Date(file.lastModified).toLocaleString(), // Last modified date
    });
  };

  return (
    <div className="flex flex-col justify-center items-center w-full">
      <label
        htmlFor="dropzone-file"
        tabIndex="0"
        aria-label="คลิกเพื่ออัปโหลดไฟล์"
        className="flex flex-col justify-center items-center w-full h-64 bg-gray-50 rounded-lg border-2 border-emerald-400 cursor-pointer hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-emerald-400"
      >
        <div className="flex flex-col justify-center items-center">
          {fileDetails ? (
            <div className="flex flex-col items-center">
              {/* XLSX Icon */}
              <div className="w-20 h-20 flex justify-center items-center bg-emerald-200 rounded-full">
                <InsertDriveFileIcon
                  style={{ fontSize: 50, color: '#5CC1A9' }}
                />
              </div>

              {/* File Metadata */}
              <div className="mt-4 text-center">
                <p className="text-sm font-medium text-gray-700">
                  <strong>ชื่อไฟล์:</strong> {fileDetails.name}
                </p>
                <p className="text-sm text-gray-500">
                  <strong>ขนาด:</strong> {fileDetails.size} KB
                </p>
                <p className="text-sm text-gray-500">
                  <strong>แก้ไขล่าสุด:</strong> {fileDetails.lastModified}
                </p>
              </div>
            </div>
          ) : (
            <div className="flex flex-col justify-center items-center rounded-full p-8 border-2 border-emerald-400 bg-white">
              <InsertDriveFileIcon style={{ fontSize: 50, color: '#5CC1A9' }} />
              <div className="mb-2 text-sm my-4 text-emerald-500">
                คลิกเพื่อเลือกไฟล์
              </div>
            </div>
          )}
        </div>
        <input
          id="dropzone-file"
          type="file"
          onChange={handleChange}
          className="hidden"
        />
      </label>
    </div>
  );
}

export default UploadFile;
